import React from "react";
import Link from "next/link";
import { observer } from "mobx-react";
import ChevronRightRound from "assets/icons/chevron-right-round.svg";
import { useStore } from "store";
import { useUrl } from "helpers/hooks";
import { CONTACT_PHONE_NUMBER } from "constants/variables";
import styles from "./Contacts.module.scss";

type Props = {
  homeUrl: string;
};

const Contacts: React.FC<Props> = ({ homeUrl }) => {
  const { getLinkProps } = useUrl();
  const { user } = useStore();
  const homeLinkProps = { href: homeUrl };

  const handleAuth = e => user.withAuth({ event: e });

  return (
    <div className={styles.footer500Contacts}>
      <div className={styles.footer500ContactsPhonesContainer}>
        <a href={`tel:${CONTACT_PHONE_NUMBER}`}>{CONTACT_PHONE_NUMBER}</a>
      </div>

      <div className={styles.footer500ContactsTimeInfo}>Круглосуточно</div>

      <Link
        {...(user.isAuth
          ? getLinkProps(`/personal/${user.profile?.id}/history/`, undefined, {
              withRegion: false,
              withOrigin: true,
            })
          : homeLinkProps)}
        className={styles.whatAboutOrder}
        onClick={handleAuth}
        passHref
      >
        Что с моим заказом?
        <ChevronRightRound />
      </Link>
    </div>
  );
};

export default observer(Contacts);
